import Client from './Client'

const LoginAPI = {}
const v2Url = '/v2/follow'

LoginAPI.install = (Vue) => {
  const vue = Vue
  vue.prototype.$LoginAPI = {
    login(data) {
      return Client.post(`${v2Url}/userLogin`, data)
    },
    register(data) {
      return Client.post(`${v2Url}/userUpdate`, data)
    },
  }
}

export default LoginAPI
